var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "jade-list-item-main-content",
      attrs: { role: "contentinfo" },
    },
    [
      _c(
        "div",
        { staticClass: "jade-list-item-main-content__label" },
        [
          _c(
            "jade-text",
            {
              attrs: {
                weight: _vm.computedLabelWeight,
                variant: _vm.computedLabelSize,
                color: _vm.computedLabelColor,
              },
            },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          ),
          _vm.tooltip
            ? _c(
                "jade-tooltip",
                { attrs: { text: _vm.tooltip, placement: "top-start" } },
                [
                  _c("jade-icon", {
                    attrs: { use: "circle-info", size: "small" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.value && !_vm.isSimple
        ? _c(
            "jade-text",
            {
              attrs: {
                variant: "text-medium",
                weight: "semibold",
                color: "high",
              },
            },
            [_vm._v(" " + _vm._s(_vm.value) + " ")]
          )
        : _vm._e(),
      _vm.isSimple
        ? [
            _vm.description
              ? _c(
                  "jade-text",
                  {
                    attrs: {
                      variant: "text-small",
                      weight: "regular",
                      color: "medium",
                      "data-testid": "description",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.description) + " ")]
                )
              : _vm._e(),
            _vm.thirdLine
              ? _c(
                  "jade-text",
                  {
                    attrs: {
                      variant: "text-small",
                      weight: "regular",
                      color: "medium",
                      "data-testid": "thirdLine",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.thirdLine) + " ")]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }